<template>
  <div class="content-page">
    <div class="container">
      <Nav v-if="$route.name !== 'result'" />

      <transition mode="out-in" name="fade">
        <router-view :key="$route.fullPath"/>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
      Nav: () => import('./Nav.vue'),
    },
  };
</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
</style>
